<!-- SECCIÓN DE BÚSQUEDA -->
<div class="validacion-amigos-thyssen">
  <div class="tituloInt tituloPago">
    {{ 'VALIDAR_AMIGOS_THYSSEN' | translate }}
  </div>
  <div class="">
    <div class="">
      <div class="InputsWrap" [formGroup]="form">

        <!-- PRIMERA FILA: NÚMERO DE AMIGO + BOTÓN BUSCAR -->
        <div class="pagoRow valePromo form-group-nocurrency">
          <div class="tit-form-group">
            {{ 'VALIDAR_AMIGO' | translate }}
          </div>
          <div class="form-group-nocurrency">
            <input
              type="text"
              class="form-control"
              formControlName="numeroAmigo"
              id="numeroAmigo"
              maxlength="40"
              placeholder="{{ 'VALIDAR_AMIGO' | translate }}"
              autocomplete="nope"
            />
            <input
              type="button"
              class="pagar aceptar"
              (click)="buscar()"
              [disabled]="buscando"
              value="{{ 'BUSCAR' | translate }}"
            />
          </div>
        </div>

        <!-- SEGUNDA FILA: DNI -->
        <div class="pagoRow">
          <div class="tit-form-group">
            {{ 'DNI' | translate }}
          </div>
          <div class="form-group-wrap">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                formControlName="dni"
                id="dni"
                maxlength="40"
                placeholder="{{ 'DNI' | translate }}"
                autocomplete="nope"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- SECCIÓN DE DATOS VALIDADOS -->
  <div *ngIf="validacion" class="seccion-datos-validados">
    <div class="ColsModPago">
      <div class="ColsModPago-der">
        <div class="InputsWrap">
          <div class="pagoRow nombre-completo">
            <div class="tit-form-group " style="color:green">
              {{ validacion.datosResult.nombreCompleto }}
            </div>
          </div>
          <div class="pagoRow">
            <div class="tit-form-group">
              {{ 'COLABORADOR' | translate }}
            </div>
            <div class="tit-form-group">
              {{ validacion.datosResult.tipoColaborador }}
            </div>
          </div>
          <div class="pagoRow">
            <div class="tit-form-group">
              {{ 'TIPO_TARJETA' | translate }}
            </div>
            <div class="tit-form-group">
              {{ validacion.datosResult.tipoTarjeta }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
